module.exports = __webpack_public_path__ + "img/step4-en@2x.4db27a8c.webp";